import React, { useState, useEffect } from "react";
import { Card, Grid, makeStyles, Switch } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  getBandejas,
  getEfectorDenunciaInternacion,
  putEfectorDenunciaInternacion,
} from "../../../../actions/autorizaciones/Autorizaciones";
import BuscadorAbm from "../../../compartidos/abms/BuscadorAbm";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import InfoHistorialIcon from "../../UI/InfoHistorialIcon";
import { TIPOS_AUTORIZACIONES, TIPO_TRACKING_ABM } from "../../../../utils/constants";
import ModalHistoricoTrackingAbm from "../../../compartidos/abms/ModalHistoricoTrackingAbm";

const useStyles = makeStyles({
  root: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "1rem",
  },
  switchBase:{
    color: '#bdbdbd',
    '&$checked': {
        transform: 'translateX(16px)',
        color: '#4CAF50',
        '& + $track': {
          backgroundColor: '#3E8040',
          opacity: 1,
          border: 'none',
        },
      },
  },  
  checked:{},
  track: {},
});

export const AbmEfectorAuditoriaTerrenoHome = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { efectorDenunciaInternacion : efector } = useSelector(
    (state) => state.autorizaciones
  );

  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [idClave, setIdClave] = useState(false);
  const [descripcion, setDescripcion] = useState(false);

  useEffect(() => {
    dispatch(getBandejas());
    dispatch(getEfectorDenunciaInternacion(TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION));
  }, [dispatch]);

  const handleSearch = (texto) => {
    dispatch(getEfectorDenunciaInternacion(TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION, texto));
  };

  const handleChangeSwitch = (e, item) => {
    const data = {
      idCartillaPrestadores: item.idCartillaPrestador,
      auditoriaTerreno: e.target.checked,
    };

    dispatch( putEfectorDenunciaInternacion(data) );
  };

  return (
    <React.Fragment>
      {openModalInfo && (
        <ModalHistoricoTrackingAbm
          open={openModalInfo}
          onClose={() => setOpenModalInfo(false)}
          idClave={idClave}
          descripcion={descripcion}
          tipoTrackingId={TIPO_TRACKING_ABM.EFECTOR_AUDITOR_TERRENO}
        />
      )}
      <Grid container justify="center">
        <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar Efector" handleSearch={handleSearch} />
        </Grid>
        <Grid item xs={12} md={9} style={{ marginTop: "2rem" }}>
          <Card>
            <TableGeneric
              data={efector}
              sizeTableCells={["8", "25%", "25%", "15%", "15%", "10%", "10%"]}
              columns={[
                {
                  label: "",
                  id: "",
                  sort: false,
                  customBody: (item) => (
                    <InfoHistorialIcon
                      onClick={() => {
                        setOpenModalInfo(true);
                        setIdClave(item?.idCartillaPrestador);
                        setDescripcion(`${item?.prestadorNombreApellido} - ${item?.domicilio} - ${item?.localidad}`);
                      }}
                    />
                  ),
                },
                // {
                //   label: "Razon Social",
                //   id: "efector.razonSocial",
                //   sort: true,
                //   customBody: (item) =>
                //     `${item?.razonSocial}`,
                // },
                // {
                //   label: "Nombre Fantasía",
                //   id: "efector.nombreFantasia",
                //   sort: true,
                //   customBody: (item) =>
                //     `${item?.nombreFantasia}`,
                // },
                {
                  label: "Nombre",
                  id: "efector.prestadorNombreApellido",
                  sort: true,
                  customBody: (item) =>
                    `${item?.prestadorNombreApellido}`,
                },
                {
                  label: "Domicilio",
                  id: "efector.domicilio",
                  sort: true,
                  customBody: (item) =>
                    `${item?.domicilio}`,
                },
                {
                  label: "Provincia",
                  id: "efector.provincia",
                  sort: true,
                  customBody: (item) =>
                    `${item?.provincia}`,
                },
                {
                  label: "Localidad",
                  id: "efector.localidad",
                  sort: true,
                  customBody: (item) =>
                    `${item?.localidad}`,
                },
                {
                  label: "Teléfono",
                  id: "efector.telefono",
                  sort: true,
                  customBody: (item) =>
                    `${item?.telefono}`,
                },
                {
                  label: "Email",
                  id: "efector.email",
                  sort: true,
                  customBody: (item) =>
                    `${item?.email ? item?.email : ''}`,
                },
                {
                  label: "Auditoria Terreno",
                  id: "efector.auditoriaTerreno",
                  sort: false,
                  customBody: (item) => (
                    <Switch
                      checked={item?.auditoriaTerreno}
                      value={item?.auditoriaTerreno}
                      name="auditoriaTerreno"
                      onChange={(e) => handleChangeSwitch(e, item)}
                      classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                    />
                  ),
                },
              ]}
            />
          </Card>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
